import { render, staticRenderFns } from "./sixPage.vue?vue&type=template&id=72de704e&scoped=true&"
import script from "./sixPage.vue?vue&type=script&lang=js&"
export * from "./sixPage.vue?vue&type=script&lang=js&"
import style0 from "./sixPage.vue?vue&type=style&index=0&id=72de704e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de704e",
  null
  
)

export default component.exports